var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleEditForm from "../../components/articleattributes/articleeditform.vue";
import { isAssembly, isManufacturableAssemblyPart, isPurchasedPart, isManufacturablePartBase, } from "../utilities/documentdialog";
import { convertToWsi4Data, } from "../utilities/wsi4conversion";
let ArticleAttributes = class ArticleAttributes extends Vue {
    constructor() {
        super(...arguments);
        this.hasArticleDataChanged = false;
    }
    rotationChange(e) { return e; }
    articleDataChange(b) {
        this.hasArticleDataChanged = b;
        return b;
    }
    emitArticleData(articleData) {
        const converted = convertToWsi4Data(this.projectEntry, articleData, this.shopConfig);
        if (!this.networkBroker.queueChangeAttributesRequest(converted)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    deleteKey() {
        if (this.hasArticleDataChanged) {
            this.articleDataChange(!this.hasArticleDataChanged);
        }
        if (isAssembly(this.projectEntry)) {
            this.deleteAssembly();
            return;
        }
        if (!this.networkBroker.queueDeleteRequest([this.projectEntry.vertexKey])) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    deleteAssembly() {
        if (!isAssembly(this.projectEntry)) {
            throw Error("Wrong type.");
        }
        const vertices = [
            this.projectEntry.vertexKey,
            ...this.projectEntry.parts.reduce((res, p) => {
                if (!isManufacturableAssemblyPart(p)) {
                    return [
                        ...res,
                        p.vertexKey,
                    ];
                }
                return [
                    ...res,
                    p.vertexKey,
                    p.vertexKeyOfSheetCutting,
                ];
            }, []),
        ].filter((value, index, self) => self.indexOf(value) === index);
        if (!this.networkBroker.queueDeleteRequest(vertices)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    emitDisassembleArticle() {
        if (!this.networkBroker.queueDisassembleRequest(this.projectEntry.vertexKey)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    forceSheetMetalPart(force) {
        if (!this.networkBroker.queueChangeAttributesRequest([
            {
                vertexKey: this.projectEntry.vertexKey,
                attributes: {
                    forceSheetMetalPart: force,
                },
                additionalProcesses: [],
            },
        ])) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    get showDisassembleButton() { return isAssembly(this.projectEntry); }
    get showSheetMetalPartForcingButton() {
        return this.networkBroker.configuration.sheetMetalPartForcing.tag === "enabled" && isPurchasedPart(this.projectEntry) && this.projectEntry.canForce;
    }
    get showPurchasedPartForcingButton() {
        return this.networkBroker.configuration.sheetMetalPartForcing.tag === "enabled" && isManufacturablePartBase(this.projectEntry) && this.projectEntry.forcedProcessType;
    }
    get requestForcing() {
        return this.networkBroker.configuration.sheetMetalPartForcing.tag === "enabled" && this.networkBroker.configuration.sheetMetalPartForcing.type === "request";
    }
};
__decorate([
    Prop({ required: true })
], ArticleAttributes.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], ArticleAttributes.prototype, "projectEntry", void 0);
__decorate([
    Inject()
], ArticleAttributes.prototype, "networkBroker", void 0);
__decorate([
    Inject()
], ArticleAttributes.prototype, "i18n", void 0);
__decorate([
    Emit()
], ArticleAttributes.prototype, "rotationChange", null);
__decorate([
    Emit()
], ArticleAttributes.prototype, "articleDataChange", null);
ArticleAttributes = __decorate([
    Component({
        components: {
            ArticleEditForm,
        },
        name: "ArticleAttributes",
    })
], ArticleAttributes);
export default ArticleAttributes;
